import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { ExportableForms } from "app/services/api/types/forms/enums/FormEnums";
import { Button, ButtonText } from "ui/gluestack/button";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { useExportFormEntry } from "../hooks/useExportFormEntry";

interface Props {
  entry: SubmittedFormModel;
}

export function AssessmentEntryExportAction({ entry }: Props) {
  const { exportToPdf, isExporting } = useExportFormEntry({
    entry,
  });

  if (!ExportableForms.includes(entry.form.tag)) return null;

  return (
    <PermissionCheck permission={PermissionsEnums.VIEW_FORM_ENTRIES}>
      <Button
        action="secondary"
        variant="outline"
        onPress={exportToPdf}
        disabled={isExporting}
      >
        <ButtonText>Export</ButtonText>
      </Button>
    </PermissionCheck>
  );
}
